'use client';

interface MentionOverlayProps {
  content: string;
  className?: string;
}

export function MentionOverlay({ content, className = '' }: MentionOverlayProps) {
  // Parse @mentions and render them with styling
  const parseContent = (text: string) => {
    const mentionRegex = /@(\w+)/g;
    const parts = text.split(mentionRegex);

    return parts.map((part, index) => {
      // Every odd index is a username (captured group from regex)
      if (index % 2 === 1) {
        return (
          <span key={index} style={{ color: '#40A6FF' }}>
            @{part}
          </span>
        );
      }
      return (
        <span key={index} style={{ color: 'white' }}>
          {part}
        </span>
      );
    });
  };

  return (
    <div
      className={`absolute inset-0 pointer-events-none whitespace-pre-wrap break-words text-zinc-2 ${className}`}
      style={{
        // Match textarea padding and styling exactly
        padding: '8px 12px', // py-2 px-3
        lineHeight: '1.5',
        fontSize: 'inherit',
        fontFamily: 'inherit',
        overflow: 'hidden',
        wordBreak: 'break-word',
      }}
    >
      {parseContent(content)}
    </div>
  );
}
